<template>
  <v-form ref="form">
    <v-data-table
      :headers="headers"
      :items="bank"
      :search="search"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Bank</v-toolbar-title>

          <v-divider class="mx-3" inset vertical left></v-divider>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                New Bank
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-col xs="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.BankName"
                        label="Bank Name"
                        prepend-inner-icon="person"
                        :rules="[rules.required]"
                        clearable
                        dense
                        filled
                        outlined
                        counter
                      ></v-text-field>
                    </v-col>
                    <v-col xs="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.BranchName"
                        label="Branch Name"
                        prepend-inner-icon="person"
                        :rules="[rules.required]"
                        clearable
                        dense
                        filled
                        outlined
                        counter
                      ></v-text-field>
                    </v-col>
                    <v-col xs="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedItem.BranchCode"
                        label="Branch Code"
                        prepend-inner-icon="person"
                        :rules="[rules.required]"
                        clearable
                        dense
                        filled
                        outlined
                        counter
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      ></v-text-field>
                    </v-col>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="close"
                  >Cancel</v-btn
                >
                <v-btn color="primary" dark class="mb-2" @click="validate"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    dialogDelete: false,
    show1: false,
    id: "",
    search: "",
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 8 || "Min 8 characters",
      counteraddMin: (value) => value.length >= 4 || "Min 4 digits",
    },
    headers: [
      { text: "Bank Name", align: "left", sortable: true, value: "BankName" },
      { text: "Branch Name", value: "BranchName" },
      { text: "Branch Code", value: "BranchCode" },
      { text: "Actions", value: "actions", sortable: false, align: "center" },
    ],
    bank: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      BankName: "",
      BranchName: "",
      BranchCode: "",
    },
    defaultItem: {
      id: "",
      BankName: "",
      BranchName: "",
      BranchCode: "",
    },
  }),
  beforeMount: function () {
    let self = this;
    self.getBanks();
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Bank" : "Edit Bank";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {},
  methods: {
    getBanks: function () {
      this.axios({
        method: "get",
        mode: "no-cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        url: `${this.$hostname}/api/banks`,
      }).then((response) => (this.bank = response.data));
    },
    postInsertBank: function () {
      const data = {
        BankName: this.editedItem.BankName,
        BranchName: this.editedItem.BranchName,
        BranchCode: this.editedItem.BranchCode,
      };
      this.axios({
        method: "post",
        mode: "no-cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        url: `${this.$hostname}/api/banks`,
        data: data,
      }).then((response) => {
        this.dbres = response.data;
      });
    },
    postUpdateBank: function () {
      const data = {
        id: this.editedItem.id,
        BankName: this.editedItem.BankName,
        BranchName: this.editedItem.BranchName,
        BranchCode: this.editedItem.BranchCode,
      };
      this.axios({
        method: "put",
        mode: "no-cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        url: `${this.$hostname}/api/banks/${this.editedItem.id}`,
        data: data,
      }).then((response) => {
        this.dbres = response.data;
      });
    },
    postDeleteBank: function () {
      const data = {
        id: this.id,
      };

      this.axios({
        method: "delete",
        mode: "no-cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        url: `${this.$hostname}/api/banks/${this.id}`,
        data: data,
      }).then((response) => {
        this.dbres = response.data;
      });
    },
    editItem(item) {
      this.editedIndex = this.bank.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.id = item.id;
      const index = this.bank.indexOf(item);
      if (confirm("Are you sure you want to delete this bank?")) {
        this.bank.splice(index, 1);
        this.postDeleteBank();
      }
    },

    close() {
      this.dialog = false;
      // setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      // }, 300)
      this.$refs.form.resetValidation();
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.bank[this.editedIndex], this.editedItem);
      } else {
        this.bank.push(this.editedItem);
      }
      this.close();
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.bank[this.editedIndex], this.editedItem);
          this.postUpdateBank();
        } else {
          this.postInsertBank();
          this.bank.push(this.editedItem);
        }
        this.$refs.form.resetValidation();
        this.close();
      }
    },
  },
};
</script>
